"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _isString2 = _interopRequireDefault(require("lodash/isString"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

require("core-js/modules/es6.regexp.split.js");

require("core-js/modules/es6.array.slice.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@ucloud-fe/react-components");

var _Typography = _interopRequireDefault(require("../Typography"));

var _excluded = ["text", "maxLength", "ellipsis", "direction", "basedOn", "component", "showTip", "popoverProps", "tipStyle"];

var _this = void 0;

/**
 * TextEllipsis
 * @description 限制文本展示长度
 */
var TextEllipsis = function TextEllipsis(_ref) {
  var _this2 = this;

  (0, _newArrowCheck2["default"])(this, _this);
  var text = _ref.text,
      maxLength = _ref.maxLength,
      ellipsis = _ref.ellipsis,
      direction = _ref.direction,
      basedOn = _ref.basedOn,
      component = _ref.component,
      showTip = _ref.showTip,
      popoverProps = _ref.popoverProps,
      tipStyle = _ref.tipStyle,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  if (!(0, _isString2["default"])(text)) {
    return null;
  }

  var Tag = component;
  var shouldShowTip = showTip;

  var getDisplayText = function getDisplayText(text, maxLength, ellipsis, basedOn, direction) {
    (0, _newArrowCheck2["default"])(this, _this2);

    if (maxLength < 0) {
      shouldShowTip = false;
      return text;
    }

    if (basedOn === "words") {
      var units = text.split(/\b|(?=\W)/);
      var result = [];
      var count = 0;
      var index = 0;

      do {
        var unit = direction === "fromStart" ? units[index] : units[units.length - 1 - index];
        /* eslint-disable no-control-regex */

        if (/[^\x00-\xff]|\w/.test(unit)) count++;
        direction === "fromStart" ? result.push(unit) : result.unshift(unit);
        index++;
      } while (index < units.length && count < maxLength);

      if (count < maxLength) {
        shouldShowTip = false;
        return text;
      }

      return direction === "fromStart" ? result.join("") + ellipsis : ellipsis + result.join("");
    }

    if (text.length <= maxLength) {
      shouldShowTip = false;
      return text;
    }

    if (maxLength - ellipsis.length <= 0) {
      return "";
    }

    return direction === "fromStart" ? text.slice(0, maxLength - ellipsis.length) + ellipsis : ellipsis + text.slice(-maxLength + ellipsis.length);
  }.bind(this); // 根据字符自动判断basedOn


  var getBasedOn = function getBasedOn(basedOn, text) {
    (0, _newArrowCheck2["default"])(this, _this2);

    /* eslint-disable no-control-regex */
    return basedOn || (/^[\x00-\x7F]+$/.test(text) ? "words" : "letters");
  }.bind(this);

  var content = /*#__PURE__*/_react["default"].createElement(Tag, others, getDisplayText(text, maxLength, ellipsis, getBasedOn(basedOn, text), direction));

  if (shouldShowTip) {
    return /*#__PURE__*/_react["default"].createElement(_reactComponents.Tooltip, (0, _extends2["default"])({
      popup: /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        size: "sm",
        style: tipStyle
      }, text),
      getPopupContainer: function () {
        (0, _newArrowCheck2["default"])(this, _this2);
        return document.body;
      }.bind(this)
    }, popoverProps, {
      arrow: false
    }), content);
  }

  return content;
}.bind(void 0);

TextEllipsis.propTypes = {
  /**
   * 需要展示的文本
   */
  text: _propTypes["default"].string.isRequired,

  /**
   * 展示文本的最大长度（含ellipsis）
   */
  maxLength: _propTypes["default"].number.isRequired,

  /**
   * 表示省略号的字符
   */
  ellipsis: _propTypes["default"].string,

  /**
   * 文本截取方向
   */
  direction: _propTypes["default"].oneOf(["fromStart", "fromEnd"]),

  /**
   * 截断长度的基准，默认根据字符判断，可选基于字母或单词，中文无区别
   */
  basedOn: _propTypes["default"].oneOf(["letters", "words"]),

  /**
   * 设置标签类型
   */
  component: _propTypes["default"].elementType,

  /**
   * 是否在被截断后，通过鼠标移入浮层展示完整文本
   */
  showTip: _propTypes["default"].bool,

  /**
   * 鼠标移入浮层的样式
   */
  tipStyle: _propTypes["default"].object,

  /**
   * 鼠标移入浮层基于基础组件Popover的props
   */
  popoverProps: _propTypes["default"].object
};
TextEllipsis.defaultProps = {
  ellipsis: "...",
  direction: "fromStart",
  component: "div",
  showTip: true,
  popoverProps: {},
  tipStyle: {}
};
var _default = TextEllipsis;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/TextEllipsis/TextEllipsis.js
// module id = 2112
// module chunks = 6 7 17 18